import { GetPropertyByUserResponse } from "@/types/property";
import { axiosWithoutToken, axiosWithToken } from "@/utils/axios";
import { AxiosResponse } from "axios";

export interface BundleBalanceResponse {
  status: string;
  message: string;
  data: {
    bundleBalance: number;
    inspectionReportBundle: number;
    liveInspectionReportBundle: number;
  };
}

export interface HasSeenListingPolicyResponse {
  status: string;
  message: string;
  data: {
    has_seen_listing_policy_banner: boolean;
  };
}

class ServiceClass {
  getUserDetails(payload: { id?: string }) {
    return axiosWithToken().get("/user/details", {
      params: payload,
    });
  }

  updateUserProfile(payload: {
    phone_number: string;
    city: string;
    state: string;
    first_name: string;
    last_name: string;
  }) {
    return axiosWithToken().patch("/user/details", {
      ...payload,
    });
  }

  changeUserPassword(payload: {
    current_password: string;
    new_password: string;
  }) {
    return axiosWithToken().post("/user/change_password", {
      ...payload,
    });
  }

  changeUserEmail(payload: { current_email: string; new_email: string }) {
    return axiosWithToken().post("/user/change_email", {
      ...payload,
    });
  }

  verifyUserEmail(payload: {
    current_email: string;
    new_email: string;
    otp_code: string;
  }) {
    return axiosWithToken().post("/user/verify_email", {
      ...payload,
    });
  }

  deleteAccount(payload: { password: string; deletion_reason: string }) {
    return axiosWithToken().patch("/user/delete_user", {
      ...payload,
    });
  }

  contactUs(payload: any) {
    return axiosWithoutToken.post("/user/contact_us", {
      ...payload,
    });
  }

  getBundleBalance(): Promise<AxiosResponse<BundleBalanceResponse>> {
    return axiosWithToken().get("/user/bundle_balance");
  }

  getHasSeenListingPolicy(): Promise<
    AxiosResponse<HasSeenListingPolicyResponse>
  > {
    return axiosWithToken().get("/user/has_seen_listing_policy");
  }

  updateHasSeenListingPolicy(payload: {
    has_seen_listing_policy_banner: boolean;
  }) {
    return axiosWithToken().patch("/user/has_seen_listing_policy", payload);
  }

  getPropertiesByUser(
    userId: string,
    params?: {
      pageNumber?: number;
      pageSize?: number;
      cursor?: string;
      beforeCursor?: string;
      location?: string;
      listingType?: string;
      propertyType?: string;
      status?: string;
    },
  ): Promise<AxiosResponse<GetPropertyByUserResponse>> {
    return axiosWithToken().get(`/user/${userId}/properties`, { params });
  }

  acknowledgeMou(payload: {
    mou_agreement_acknowledged: boolean;
    token: string;
  }) {
    return axiosWithoutToken.post("/mou/acknowledge", payload);
  }
}

const UserService = new ServiceClass();
export default UserService;
